"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VocabularyTerm = exports.VocabularyItemProperties = void 0;
var vocabulary_list_1 = require("./vocabulary-list");
exports.VocabularyItemProperties = ['id', 'type', 'image_id', 'image', 'user_id', 'term', 'term_language_id', 'term_transcription', 'term_voice_id', 'term_voice', 'definition', 'definition_language_id', 'definition_transcription', 'definition_voice_id', 'definition_voice', 'definition', 'definition_transcription', 'vocabulary_list_id', 'vocabulary_list'];
var VocabularyTerm = /** @class */function () {
  function VocabularyTerm(values) {
    if (values === void 0) {
      values = {};
    }
    var properties = exports.VocabularyItemProperties;
    var instance = this;
    properties.forEach(function (p) {
      if (p in values) {
        instance[p] = values[p];
      }
    });
    if (values.vocabulary_list) {
      this.vocabulary_list = new vocabulary_list_1.VocabularyList(values.vocabulary_list);
    }
  }
  return VocabularyTerm;
}();
exports.VocabularyTerm = VocabularyTerm;
